import type { Getter, Setter } from 'jotai';
import type { UndoRedoActionCommand } from '../../../../../modernization-common/undo-redo/types';
import type { FrameAnnotationInfo } from '../../../studio-store/types';
import { buildAnnotationForOutput } from '../../../utils/build-annotation-for-output';
import { annotationLabelsAtom, annotationMetadataAtom, loadedAnnotationFramesAtom } from '../../annotation-atoms';
import type { AnnotationFrameWriteEntry } from '../../studio-store-write/actions';
import { STUDIO_WRITE_ACTIONS } from '../../studio-store-write/actions';
import { dispatchStudioStoreWriteAtom } from '../../studio-store-write/dispatch-studio-store-write';
import { selectedAnnotationIdsAtom } from '../../tool-atoms';
import { currentFrameAtom } from '../../video-playback-atoms';
import type { DeleteSelectedAnnotationsEventPayload } from '../events';
export const deleteSelectedAnnotationsCommandFactory = (get: Getter, set: Setter): UndoRedoActionCommand<DeleteSelectedAnnotationsEventPayload, void> => {
  let deletedAnnotations: AnnotationFrameWriteEntry[] = [];
  let previousSelectedIds: string[] = [];
  return {
    execute: () => {
      const currentFrame = get(currentFrameAtom);
      const selectedIds = get(selectedAnnotationIdsAtom);
      const frameMap = get(loadedAnnotationFramesAtom).get(currentFrame);
      if (!frameMap) {
        return;
      }
      const metadata = get(annotationMetadataAtom);
      const annotationLabels = get(annotationLabelsAtom);
      previousSelectedIds = selectedIds;
      deletedAnnotations = [];
      for (const [id, framePayload] of frameMap) {
        if (!selectedIds.includes(id)) {
          continue;
        }
        const meta = metadata.get(id);
        if (!meta) {
          continue;
        }
        deletedAnnotations.push({
          frameIndex: currentFrame,
          annotationId: id,
          annotation: buildAnnotationForOutput(framePayload, meta, annotationLabels, currentFrame)
        });
      }
      if (!deletedAnnotations.length) {
        return;
      }
      const deletes: FrameAnnotationInfo[] = deletedAnnotations.map(({
        frameIndex,
        annotationId
      }) => ({
        frameIndex,
        annotationId
      }));
      set(dispatchStudioStoreWriteAtom, {
        type: STUDIO_WRITE_ACTIONS.BULK_DELETE,
        deletes
      });
      set(selectedAnnotationIdsAtom, []);
    },
    undo: () => {
      if (!deletedAnnotations.length) return;
      set(dispatchStudioStoreWriteAtom, {
        type: STUDIO_WRITE_ACTIONS.BULK_WRITE,
        writes: deletedAnnotations
      });
      set(selectedAnnotationIdsAtom, previousSelectedIds);
    }
  };
};